<template>
  <v-form ref="PostcodesForm" @submit.prevent v-model="valid">
    <v-card-text>
      <v-text-field
        label="Postcode"
        v-model="postcode"
        type="text"
        :rules="[required('Postcode'), isPostcodeFirstHalf]"
        hint="First part of delivery postcode"
        persistent-hint
      />

      <v-switch v-model="DeliverOnSunday" color="blue darken-2" inset>
        <template v-slot:label>
          Deliver On Sunday
          <v-icon right :color="DeliverOnSunday ? 'success' : 'error'">
            {{ DeliverOnSunday ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>
      </v-switch>

      <v-switch v-model="DeliverOnMonday" color="blue darken-2" inset>
        <template v-slot:label>
          Deliver On Monday
          <v-icon right :color="DeliverOnMonday ? 'success' : 'error'">
            {{ DeliverOnMonday ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>
      </v-switch>

      <v-switch v-model="DeliverOnTuesday" color="blue darken-2" inset>
        <template v-slot:label>
          Deliver On Tuesday
          <v-icon right :color="DeliverOnTuesday ? 'success' : 'error'">
            {{ DeliverOnTuesday ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>
      </v-switch>

      <v-switch v-model="DeliverOnWednesday" color="blue darken-2" inset>
        <template v-slot:label>
          Deliver On Wednesday
          <v-icon right :color="DeliverOnWednesday ? 'success' : 'error'">
            {{ DeliverOnWednesday ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>
      </v-switch>

      <v-switch v-model="DeliverOnThursday" color="blue darken-2" inset>
        <template v-slot:label>
          Deliver On Thursday
          <v-icon right :color="DeliverOnThursday ? 'success' : 'error'">
            {{ DeliverOnThursday ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>
      </v-switch>

      <v-switch v-model="DeliverOnFriday" color="blue darken-2" inset>
        <template v-slot:label>
          Deliver On Friday
          <v-icon right :color="DeliverOnFriday ? 'success' : 'error'">
            {{ DeliverOnFriday ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>
      </v-switch>

      <v-switch v-model="DeliverOnSaturday" color="blue darken-2" inset>
        <template v-slot:label>
          Deliver On Saturday
          <v-icon right :color="DeliverOnSaturday ? 'success' : 'error'">
            {{ DeliverOnSaturday ? "check_circle_outline" : "cancel" }}
          </v-icon>
        </template>
      </v-switch>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        large
        type="submit"
        :loading="$store.getters.postcodesLoading"
        color="blue darken-2"
        @click="submit"
        outlined
        :disabled="!valid"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import checkPostCode from "@/util/validation/postcode.js";

export default {
  name: "AddOrderDiscount",
  //^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$
  data: () => {
    return {
      valid: false,

      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },

      isPostcodeFirstHalf: (v) => {
        return (
          /^([A-PR-UWYZa-pr-uwyz]([0-9]{1,2}|([A-HK-Ya-hk-y][0-9]|[A-HK-Ya-hk-y][0-9]([0-9]|[ABEHMNPRV-Yabehmnprv-y]))|[0-9][A-HJKS-UWa-hjks-uw]))$/.test(
            v
          ) || "Postcode is not valid"
        );
      },

      postcode: null,
      DeliverOnSunday: true,
      DeliverOnMonday: true,
      DeliverOnTuesday: true,
      DeliverOnWednesday: true,
      DeliverOnThursday: true,
      DeliverOnFriday: true,
      DeliverOnSaturday: true,
    };
  },

  methods: {
    ...mapActions(["addPostcode"]),

    async submit() {
      console.log("Submit New Postcode");

      let data = {
        postcode: this.postcode,
        DeliverOnSunday: this.DeliverOnSunday ? 1 : 0,
        DeliverOnMonday: this.DeliverOnMonday ? 1 : 0,
        DeliverOnTuesday: this.DeliverOnTuesday ? 1 : 0,
        DeliverOnWednesday: this.DeliverOnWednesday ? 1 : 0,
        DeliverOnThursday: this.DeliverOnThursday ? 1 : 0,
        DeliverOnFriday: this.DeliverOnFriday ? 1 : 0,
        DeliverOnSaturday: this.DeliverOnSaturday ? 1 : 0,
      };

      let result = await this.addPostcode(data);

      if (result) {
        this.$router.push({ name: "MaintenancePostcodes" });

        this.postcode = null;
        this.DeliverOnSunday = true;
        this.DeliverOnMonday = true;
        this.DeliverOnTuesday = true;
        this.DeliverOnWednesday = true;
        this.DeliverOnThursday = true;
        this.DeliverOnFriday = true;
        this.DeliverOnSaturday = true;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>